// ru_RU.js
const ru_RU = {
    "首页": "Главная",
    '收藏': 'Избранное',
    home: {
      "GLOBAL INDUSTRIAL INTELLIGENCE TRADING PLATFORM": "ГЛОБАЛЬНАЯ ПЛАТФОРМА ИНТЕЛЛЕКТУАЛЬНОЙ ПРОМЫШЛЕННОЙ ТОРГОВЛИ",
      "设备分类": "Категории оборудования",
      "请输入内容": "Введите содержание",
      "请输入关键词": "Введите ключевые слова",
      "搜索": "Поиск",
      "供应大厅": "Зал предложений",
      "查看更多": "Показать больше",
      "采购大厅": "Зал закупок",
      "截止日期": "Срок подачи заявок",
      "交货期限": "Срок поставки",
      "数量": "Количество",
      "去询价": "Запросить цену",
      "平台介绍": "О платформе",
      "新闻动态": "Новости",
      "产品名称": "Название продукта",
      "产品描述": "Описание продукта",
      "供应商": "Поставщик",
      "月供应量": "Месячный объем поставок",
      "物流方式": "Способ доставки",
      "询价": "Запрос цены",
      "平台介绍详情": "Создание \"одного стандарта, двух экосистем, трех активов\" с акцентом на импорт и экспорт авиационных промышленных товаров. На основе выставки Zhuhai Airshow расширяем бизнес, делая торговлю нормализованной, цифровой и международной. Цель — стать мировой комплексной сервисной платформой для авиационной промышленности.",
      "琴航航空工业品平台": "Qinhang Авиапродукция",
      "推荐品牌": "Рекомендуемые бренды",
      "推荐":'Рекомендуется',
      "全球工业化智能解决方案": "Глобальные интеллектуальные промышленные решения",
      "二手飞机推荐": "Рекомендации по подержанным самолетам",
      "供求大厅": "Зал спроса и предложения",
      "更多供求": "Больше предложений",
      "全面定制化供应链服务": "Комплексные индивидуальные услуги цепочки поставок",
      "立即体验AI助手": "Попробуйте AI-ассистента",
      "AI助手": "AI-ассистент"
    },
    aiObject: {
      "title": "AI-ассистент",
      "connected": "Подключено",
      "placeholder": "Введите ваш вопрос",
      "send": "Отправить",
      "stop": "Остановить генерацию",
      "clear": "Очистить историю",
      "welcome": "Здравствуйте! Я AI-ассистент. Чем могу помочь?",
      "thinking": "Обдумываю...",
      "error": "Извините, я не могу ответить на ваш вопрос сейчас. Пожалуйста, попробуйте позже.",
      "networkError": "Извините, проблема с сетевым подключением. Пожалуйста, попробуйте позже.",
      "stopped": "Генерация остановлена",
      "confirmClose": "AI-ассистент генерирует ответ. Вы уверены, что хотите закрыть?",
      "notice": "Уведомление",
      "confirm": "Подтвердить",
      "cancel": "Отмена"
    },
    PageHeader: {
      "首页": "Главная",
      "供应大厅": "Зал предложений",
      "采购大厅": "Зал закупок",
      "二手飞机库": "подержанный самолёт",
      "备件商城": "Магазин запчастей",
      "招采平台": "Платформа закупок",
      "解决方案": "Решения",
      "新闻中心": "Новости",
      "关于我们": "О нас",
      "简体中文": "简体中文",
      "登录/注册": "Вход/Регистрация",
      "欢迎您走进琴航科技": "Добро пожаловать в Qinhang Technology",
      "已退出登录":'Выход выполнен'
    },
    reservation: {
      "预约": "Запись",
      
      // 头部横幅文本
      "title1": "Встречайте Connect Tech на выставке IDEF",
      "title2": "2025",
      "title3": "Все участники оборонной промышленности под одной крышей",
      "title4": "22-27 июля 2025 - Стенд 8-C14A",
      
      // 内容描述段落
      "desc1": "IDEF 2025 - 17-я Международная выставка оборонной промышленности будет организована Министерством обороны Турецкой Республики при поддержке Секретариата оборонной промышленности при Президенте Турецкой Республики, под управлением Фонда Вооруженных сил Турции и проводиться компанией KFA Fair Organization с 22 по 27 июля 2025 года в Стамбульском выставочном центре.",
      "desc2": "Присоединяйтесь к Connect Tech и партнеру",
      "desc2_link": "Bernier",
      "desc2_cont": "на стенде 8-C14A. Как элитный партнер NVIDIA, Connect Tech предлагает компактные, низкопотребляющие и защищенные решения для пилотируемых и беспилотных применений. Эти мощные периферийные устройства легко переносятся или развертываются на различных транспортных средствах, обеспечивая принятие решений в реальном времени на тактической границе.",
      "desc3": "Запишитесь на встречу сейчас, чтобы подробно обсудить ваше применение и узнать о потенциальных решениях для ваших конкретных требований к дизайну.",
      "desc4": "Пожалуйста, заполните форму для организации встречи.",
      "required_note": "обязательные поля",
      
      // 表单标签
      "label_salutation": "Обращение:",
      "label_first_name": "Имя:",
      "label_last_name": "Фамилия:",
      "label_email": "Email:",
      "label_job_title": "Должность:",
      "label_company": "Компания:",
      "label_phone": "Телефон:",
      "label_country": "Страна:",
      "label_message": "Сообщение:",
      
      // 占位符文本
      "ph_choose": "—Пожалуйста, выберите опцию—",
      "ph_first_name": "Введите ваше имя",
      "ph_last_name": "Введите вашу фамилию",
      "ph_email": "Введите ваш email",
      "ph_job_title": "Введите вашу должность",
      "ph_company": "Введите вашу компанию",
      "ph_phone": "Введите ваш номер телефона",
      "ph_country": "Введите вашу страну",
      "ph_message": "Введите ваше сообщение или конкретные требования",
      
      // 按钮和状态文本
      "btn_submit": "Отправить",
      "btn_submitting": "Отправка...",
      "msg_success": "Запись успешно отправлена! Мы свяжемся с вами в ближайшее время.",
      "msg_validation": "Пожалуйста, правильно заполните все обязательные поля",
      "msg_error": "Не удалось отправить запись. Пожалуйста, попробуйте снова."
    },
    CommonFooter: {
      "琴航（广东横琴）科技有限公司": "Qinhang (Гуандун Хэнцинь) Технологии Лтд.",
      "400-000-0000": "400-000-0000",
      "地址：珠海市香洲区厚朴道398号横琴国际科技创新中心 7栋708-2": "Адрес: Здание 7, Комната 708-2, Международный научно-технический инновационный центр Хэнцинь, Хоупу Роуд 398, Район Сянчжоу, Чжухай",
      "contactEmail": "Email: Kinghang@e99.cn",
      "关于我们": "О нас",
      "供应大厅": "Зал предложений",
      "需求大厅": "Зал спроса",
      "解决方案": "Решения",
      "增值服务": "Дополнительные услуги",
      "服务": "Услуги",
      "帮助中心": "Центр помощи",
      "平台规则": "Правила платформы",
      "常见问题": "Часто задаваемые вопросы",
      "安全保障": "Безопасность",
      "联系我们": "Свяжитесь с нами",
      "© 2025 琴航（广东横琴）科技有限公司   版权所有  粤ICP备2025393208号-1": "© 2025 Qinhang (Гуандун Хэнцинь) Технологии Лтд.   Все права защищены  粤ICP备2025393208号-1",
      "热门产品分类": "Популярные категории продуктов",
      "智能无人机制造": "Производство интеллектуальных БПЛА",
      "无人机": "БПЛА",
      "螺旋桨": "Пропеллеры",
      "RC电子配件": "Электронные компоненты RC",
      "起落架和收起": "Шасси и уборка",
      "碳纤维材料": "Углеродное волокно",
      "无人机遥控器": "Пульты управления БПЛА",
      "帮助与支持": "Помощь и поддержка",
      "关于琴航": "О Qinhang",
      "了解琴航": "О компании Qinhang",
      "加入琴航": "Присоединяйтесь к нам",
      "投资者关系": "Инвесторские отношения",
      "可持续发展": "Устойчивое развитие",
      "廉洁举报": "Сообщить о нарушении",
      "新闻动态": "Новости",
      "琴航资讯": "Новости Qinhang",
      "行业动态": "Отраслевые новости",
      "最新科技": "Последние технологии",
      "Copyright © 2025 琴航（广东横琴）科技有限公司": "Copyright © 2025 Qinhang (Гуандун Хэнцинь) Технологии Лтд.",
      "版权所有": "Все права защищены",
      "使用条款": "Условия использования",
      "粤ICP备2025393208号-1": "粤ICP备2025393208号-1",
      "网站地图": "Карта сайта",
      
      "元器件": "Компоненты",
      "应急装备": "Аварийное оборудование",
      "光学传感器": "Оптические датчики",
      "mems": "МЭМС",
      "复合材料": "Композитные материалы",
      "低空飞行器": "Низковысотные летательные аппараты",
      "其他": "Другое",
      
    },
    'product-list': {
      '条件查询': 'Фильтр',
      '设备分类': 'Категория оборудования',
      '运输方式': 'Способ доставки',
      '产品标签': 'Теги продукта',
      '供应商类型': 'Тип поставщика',
      '商品名称': 'Название товара',
      '全部': 'Все',
      '供应商店铺': 'Магазин поставщика',
      '自营店铺': 'Собственный магазин',
      '请输入商品名称': 'Введите название товара',
      '搜索': 'Поиск',
      '重置': 'Сбросить',
      '共 {count} 个结果': 'Найдено {count} результатов',
      '发布时间': 'Дата публикации',
      '查看次数': 'Просмотров',
      '取消收藏': 'Удалить из избранного',
      '收藏': 'В избранное',
      '询价': 'Запрос цены',
      '人工询价': 'Запрос цены у менеджера',
      '智能询价': 'Умный запрос цены',
      '暂无产品': 'Товары не найдены',
      '解决方案应用': 'Применение решений',
      '您想要的产品': 'Нужный вам продукт',
    },
    'product-details': {
      '供应大厅': 'Зал предложений',
      '产品详情': 'Информация о продукте',
      '取消收藏': 'Удалить из избранного',
      '收藏': 'В избранное',
      '加入收藏': 'Добавить в избранное',
      '加入询盘': 'Добавить в запрос',
      '取消询盘': 'Удалить из запроса',
      '1V1专家咨询': 'Консультация эксперта 1 на 1',
      '商品详情': 'Описание товара',
      '用户案例': 'Примеры использования',
      '服务支持': 'Поддержка',
      '专家咨询': 'Консультация эксперта',
      '请留下您的联系方式，方便我们与您联系': 'Пожалуйста, оставьте ваши контактные данные для связи',
      '也可直接联系客服邮箱': 'Также вы можете написать напрямую на email службы поддержки',
      '请输入您的联系方式': 'Введите ваши контактные данные',
      '取 消': 'Отмена',
      '确 定': 'Подтвердить',
      '提交成功': 'Успешно отправлено',
      '联系我们': 'Свяжитесь с нами',
      "规格": "Характеристики",
      "价格": "Цена",
      "月供应量": "Месячный объем поставок",
      "运输方式": "Способ доставки",
      
      "规格详情": "Подробные характеристики",
      "描述": "Описание",
    },
    // 新增 purchase-list 对象
    'purchase-list': {
        '条件查询': 'Фильтр',
        '设备分类': 'Категория оборудования',
        '共 {count} 个设备': 'Найдено {count} единиц оборудования',
        '发布时间': 'Дата публикации',
        '查看次数': 'Просмотров',
        '去咨询': 'Связаться',
        '暂无产品': 'Товары не найдены',
        '截止日期': 'Крайний срок',
        '数量': 'Количество'
    },
    // 新增 purchase-details 对象
    'purchase-details': {
        '采购大厅': 'Зал закупок',
        '需求详情': 'Детали запроса',
        '进行中': 'В процессе',
        '采购数量': 'Объем закупки',
        '预算金额': 'Бюджет',
        '交货期限': 'Срок поставки',
        '距离截止还剩': 'До окончания осталось',
        '采购需求详情': 'Подробности запроса на закупку',
        '采购商详情': 'О закупщике',
        '已认证': 'Верифицирован',
        '成立时间': 'Год основания',
        '员工': 'Сотрудников',
        '相关推荐': 'Похожие предложения',
        '截止时间': 'Крайний срок',
        '采购中': 'Идет закупка',
        '数量': 'Количество',
        '已截止': 'Закончен',
        '天': 'дней',
    },
    // 新增 solution-details 对象
    solution:{
      安防光电类供应链:'Цепочка поставок систем безопасности и оптоэлектроники',
      安防光电类供应链介绍:'Цепочка поставок систем безопасности и оптоэлектроники',
      应急救援解决方案:'Решение для экстренного реагирования',
      应急救援解决方案介绍:'Данное решение основано на базовых технологиях пожарно-спасательного оборудования платформы, с системой защиты пожарных в качестве основного модуля поддержки, предоставляя эффективные, модульные и интеллектуальные комбинации оборудования и комплексную сервисную поддержку для многосценарных потребностей экстренного реагирования.',
      noticeTitle:'Решение для цепочки поставок БПЛА',
      description:'Независимо от того, нужны ли вам отдельные компоненты, такие как корпус и система питания, или полный комплект, мы можем удовлетворить клиентов эффективным и качественным сервисом.',
      返回上页:'Назад',
      '单项需求策略':'Стратегия отдельных компонентов',
      整机需求策略:'Стратегия полного комплекта',
      服务流程:'Процесс обслуживания',
      质量保障与售后服务:'Гарантия качества и послепродажное обслуживание',
      相关产品:'Связанные продукты',
      产品详情:'Детали продукта',
      了解更多产品:'Узнать больше о продуктах',
      更多产品:'Больше продуктов',
      规格:'Характеристики',
      深入了解:'Подробнее',
      相关解决方案:'Связанные решения',
      查看详情:'Посмотреть детали',
      您当前位置:'Вы находитесь',
      '您当前位置：首页': 'Вы находитесь: Главная',
        应用场景及解决方案:'Сценарии применения и решения',
        核心优势:'Основные преимущества',
        '核心优势描述':'Решение интегрирует интеллектуальное оборудование, включая гидравлические инструменты, подводное спасательное оборудование, интеллектуальных роботов, средства индивидуальной защиты и другое передовое оборудование. В сочетании со стандартизированными операционными процедурами и технической поддержкой создается замкнутая система экстренного реагирования, охватывающая "мониторинг-предупреждение — быстрое реагирование — точное устранение — обеспечение безопасности — непрерывная оптимизация", применимая к городским спасательным операциям, землетрясениям, водным поисково-спасательным операциям, авариям с опасными химическими веществами и другим сценариям, достигая двойного повышения эффективности спасения и безопасности, максимально сокращая человеческие жертвы и материальный ущерб.',
      '基础模块：消防单兵守护系统':'Базовый модуль: Система защиты пожарных',
        '消防单兵守护系统定位':'Позиционирование системы защиты пожарных',
        '消防单兵守护系统定位描述':'Система защиты пожарных является основной гарантией безопасности при экстренном реагировании. Интегрируя функции позиционирования, мониторинга и связи, она обеспечивает спасателям защиту жизни в реальном времени и предоставляет командному центру точную поддержку данных.',
        '功能模块与产品组成':'Функциональные модули и состав продукта',
        '功能模块':'Функциональные модули',
        '对应产品/技术':'Соответствующие продукты/технологии',
        '技术参数与用途':'Технические параметры и применение',
        '系统优势':'Преимущества системы',
        '应用场景':'Сценарии применения',
      // solutionList 相关翻译
      机身: 'Корпус',
      机身描述: 'Сотрудничество с известными производителями корпусов, предоставление различных<br>материалов (таких как углеродное волокно, алюминиевый сплав) и структурных конструкций<br>корпусов для удовлетворения различных требований к производительности и применению.<br>Клиенты могут выбирать в соответствии с их требованиями к весу, прочности и коррозионной стойкости',
      动力系统: 'Силовая система',
      动力系统描述: 'Интеграция качественных аккумуляторов, двигателей, электронных регуляторов скорости и пропеллеров',
      飞控系统: 'Система управления полетом',
      飞控系统描述: 'Сотрудничество с компаниями по разработке полетных контроллеров, обладающих передовыми технологиями, предоставление<br>мощных и надежных продуктов управления полетом. Оснащены различными режимами<br>полета, высокоточной технологией слияния датчиков и функцией интеллектуального избежания препятствий.<br>Можно настроить алгоритмы и функции управления полетом в соответствии с требованиями клиентов к стабильности полета, гибкости и<br>автономности.',
      传感器: 'Датчики',
      传感器描述: 'Сотрудничество с ведущими производителями датчиков, предоставление подходящих GPS,<br>гироскопов, акселерометров, барометров и других высокоточных<br>датчиков. В соответствии со сценарием применения и требованиями к производительности БПЛА<br>точный подбор и конфигурация для клиентов, например, для картографических БПЛА<br>создание GPS-сетки, обеспечение стабильности датчиков высоты и<br>расхода.',
      通信系统: 'Система связи',
      通信系统描述: 'Совместно с профессиональными поставщиками коммуникационного оборудования предоставление систем связи с различными частотными диапазонами,<br>дальностью передачи и помехоустойчивостью. Включая<br>радиостанции передачи данных, оборудование для передачи изображений и т.д., обеспечение стабильной передачи данных и изображений между БПЛА и<br>наземной станцией. Можно настроить в соответствии с<br>требованиями клиентов к дальности передачи, скорости передачи данных и конфиденциальности.',
      任务载荷: 'Полезная нагрузка',
      任务载荷描述: 'Сотрудничество с многочисленными производителями полезных нагрузок, предоставление богатого<br>выбора, такого как HD-камеры для аэрофотосъемки, мультиспектральные<br>камеры для сельскохозяйственного мониторинга, тепловизоры для<br>инспекции безопасности и т.д. В соответствии с отраслевыми потребностями клиентов,<br>настройка профессиональных решений по полезной нагрузке и интеграционных услуг.',
      // part21.vue solutionList 相关翻译
      摄像头模组: 'Камерные модули',
      摄像头模组描述: 'Сотрудничество с всемирно известными оптическими производителями, предоставление разнообразных камерных модулей высокой четкости (4K/8K), низкой освещенности, широкого динамического диапазона (WDR). Поддержка настраиваемых параметров (таких как фокусное расстояние, диафрагма, разрешение), адаптация к различным условиям освещения внутри и снаружи помещений, интеграция AI-чипов для реализации распознавания лиц, анализа поведения и других интеллектуальных функций.',
      红外热成像设备: 'Тепловизионное оборудование',
      红外热成像设备描述: 'Совместно с производителями инфракрасных детекторов предоставление некалиброванных и калиброванных тепловизионных модулей с разрешением от 160×120 до 1280×1024, точностью измерения температуры ±1℃. Поддержка круглосуточного мониторинга, применимость для охраны периметра, предупреждения пожаров и других сценариев, возможность настройки диапазона измерения температуры и алгоритмов улучшения изображения.',
      智能分析系统: 'Интеллектуальная система анализа',
      智能分析系统描述: 'Интеграция ресурсов компаний AI-алгоритмов, предоставление программных решений для структурного анализа видео, отслеживания нескольких целей, обнаружения аномального поведения. Поддержка глубокой интеграции с камерами, настройка алгоритмических моделей в соответствии с потребностями клиентов (таких как распознавание номеров, анализ плотности толпы), оптимизация граничных вычислений и совместной работы с облаком.',
      存储与传输设备: 'Оборудование для хранения и передачи',
      存储与传输设备描述: 'Сотрудничество с поставщиками оборудования для хранения, предоставление высокопроизводительных NVR (сетевых видеорегистраторов), распределенных серверов хранения и облачных решений для хранения, поддержка доступа к массивным данным в реальном времени и зашифрованного резервного копирования. Совместная разработка с телекоммуникационными компаниями высокополосных решений передачи данных с низкой задержкой (таких как 5G, оптоволокно), обеспечение стабильной передачи видеопотока.',
      辅助设备: 'Вспомогательное оборудование',
      辅助设备描述: 'Предоставление подставок, защитных кожухов, дополнительного освещения и другого вспомогательного оборудования, адаптированного к экстремальным условиям (таким как высокие температуры, проливные дожди, под водой, взрывоопасные сценарии), продление срока службы оборудования.',
      // part14.vue solutionList 相关翻译
      城市建筑坍塌救援: 'Спасение при обрушении городских зданий',
      城市建筑坍塌救援描述: 'Проблемы: низкая эффективность разрушения бетонных конструкций, высокий риск вторичного обрушения, трудности спасения в ограниченном пространстве.',
      地震灾害救援: 'Спасение при землетрясениях',
      地震灾害救援描述: 'Проблемы: сложная среда руин, трудности транспортировки тяжелого оборудования, высокий риск афтершоков.',
      水域救援: 'Водное спасение (наводнения/аварии кораблей)',
      水域救援描述: 'Проблемы: низкая видимость под водой, трудности резки препятствий, недостаточная скорость реагирования на спасение.',
      危化品泄露与火灾: 'Утечка опасных химических веществ и пожар',
      危化品泄露与火灾描述: 'Проблемы: высокий риск взрыва, быстрое распространение токсичных газов, низкая эффективность традиционного пожаротушения.',
      // part4.vue strategyList 相关翻译
      需求沟通与方案定制: 'Обсуждение требований и настройка решения',
      需求沟通与方案定制描述: 'Глубокое понимание сценариев использования БПЛА клиентом (таких как аэрофотосъемка, логистика, картография и т.д.), требований к производительности (выносливость, грузоподъемность, точность и т.д.), бюджетных ограничений и потребностей в специальных функциях, разработка подробного индивидуального решения для полного комплекта.',
      整合优质资源生产组装: 'Интеграция качественных ресурсов для производства и сборки',
      整合优质资源生产组装描述: 'Закупка высококачественных компонентов у различных поставщиков деталей, строгий контроль качества, точная сборка в соответствии с отраслевыми стандартами и требованиями клиентов, обеспечение производительности полного комплекта.',
      全面测试与质量检测: 'Комплексное тестирование и контроль качества',
      全面测试与质量检测描述: 'Проведение множественных тестов летных характеристик, надежности, адаптации к окружающей среде и т.д., строгий контроль качества каждого БПЛА в соответствии с международными и отраслевыми стандартами, гарантия соответствия поставляемой продукции.',
      售后服务与技术支持: 'Послепродажное обслуживание и техническая поддержка',
      售后服务与技术支持描述: 'Предоставление послепродажного обслуживания, включая ремонт и обслуживание, замену деталей, обновление программного обеспечения и техническое консультирование, создание механизма быстрого реагирования, своевременное решение проблем клиентов.',
      // part6.vue serviceFlowItems 相关翻译
      需求收集与分析: 'Сбор и анализ требований',
      需求收集与分析描述: 'Детальное понимание потребностей клиентов через онлайн-коммуникацию, оффлайн-визиты и другие способы, формирование отчета об анализе требований.',
      方案设计与报价: 'Проектирование решения и котирование',
      方案设计与报价描述: 'В соответствии с требованиями разработка целевого решения, предоставление подробного коммерческого предложения, включающего спецификации продукта, цену, срок поставки и другое содержание.',
      合同签订与订单确认: 'Подписание контракта и подтверждение заказа',
      合同签订与订单确认描述: 'Подписание контракта с клиентом, уточнение прав и обязанностей обеих сторон, подтверждение деталей заказа.',
      采购与生产安排: 'Закупка и организация производства',
      采购与生产安排描述: 'Закупка деталей у поставщиков, координация графика производства, контроль качества производства.',
      质量检测与测试: 'Контроль качества и тестирование',
      质量检测与测试描述: 'Проведение нескольких раундов контроля качества деталей и полного комплекта, летных испытаний, обеспечение соответствия продукта стандартам.',
      包装运输与交付: 'Упаковка, доставка и передача',
      包装运输与交付描述: 'Использование профессиональной упаковки, выбор подходящего способа доставки, обеспечение безопасной и своевременной доставки продукции.',
      售后服务: 'Послепродажное обслуживание',
      售后服务描述: 'Предоставление послепродажной поддержки, регулярные звонки клиентам, сбор отзывов, непрерывное улучшение услуг.',
      // part6.vue qualityServiceItems 相关翻译
      质量保障体系: 'Система обеспечения качества',
      质量保障体系描述: 'Создание строгой системы контроля качества, от выбора поставщиков, закупки сырья до производства, контроля, упаковки, каждый этап следует международным стандартам и отраслевым нормам.',
      售后服务团队: 'Команда послепродажного обслуживания',
      售后服务团队描述: 'Формирование профессиональной команды, предоставление сервиса 7×24 часа, решение проблем клиентов через телефон, электронную почту, удаленную помощь и другие способы.',
      售后内容: 'Содержание послепродажного обслуживания',
      售后内容描述: 'Предоставление гарантийного обслуживания на определенный срок, бесплатный ремонт или замена дефектных деталей в течение гарантийного периода; предоставление обучения эксплуатации и технического руководства; создание запаса деталей для обеспечения своевременной поставки.',
      // part22.vue strategyList 相关翻译
      需求沟通与方案定制2: 'Обсуждение требований и настройка решения',
      需求沟通与方案定制描述2: 'Глубокое исследование сценариев клиента (таких как безопасность парков, мониторинг транспортных узлов, промышленность, охватывающая выбор оборудования, программные платформы, сетевую архитектуру) для комплексного решения.',
      资源整合与系统集成: 'Интеграция ресурсов и системная интеграция',
      资源整合与系统集成描述: 'Полная цепочка закупок от основных компонентов (камеры, инфракрасные модули) до вспомогательного оборудования (хранилище, питание), строгий контроль квалификации поставщиков и совместимости продуктов. Завершение сборки оборудования и отладки программного обеспечения, обеспечение совместной работы нескольких устройств.',
      联调测试与场景验证: 'Совместное тестирование и проверка сценариев',
      联调测试与场景验证描述: 'Стресс-тестирование в симуляции реальных сценариев: включая четкость изображения, эффект ночного видения, задержку сети, точность AI-анализа и т.д., оптимизация стабильности системы и скорости отклика.',
      安装部署与运维支持: 'Установка, развертывание и поддержка эксплуатации',
      安装部署与运维支持描述: 'Предоставление руководства по установке на месте или удаленной технической поддержки, помощь клиентам в завершении развертывания системы. Создание механизма реагирования на эксплуатацию, регулярная удаленная диагностика состояния оборудования, предотвращение потенциальных сбоев.',
  
      // part12.vue features
      '技术领先性': 'Технологическое лидерство',
      '技术领先性副标题': 'Технологическое лидерство',
      '技术领先性描述': 'Легкая конструкция, модульная комбинация, технология интеллектуального управления (такая как позиционирование Beidou, тепловизионный мониторинг).',
      '场景全覆盖': 'Полный охват сценариев',
      '场景全覆盖副标题': 'Полный охват сценариев',
      '场景全覆盖描述': 'От обрушения городских зданий до подводного спасения, от утечки опасных химических веществ до лесных пожаров - предоставляются целевые комбинации оборудования.',
      '安全双保险': 'Двойная гарантия безопасности',
      '安全双保险副标题': 'Двойная гарантия безопасности',
      '安全双保险描述': 'Взрывозащищенная конструкция оборудования + система мониторинга жизненных показателей спасателей, двойная гарантия безопасности спасательного персонала.',
      '服务全周期': 'Полный цикл обслуживания',
      '服务全周期副标题': 'Полный цикл обслуживания',
      '服务全周期描述': 'Предоставление комплексной поддержки от конфигурации оборудования, обучения эксплуатации до послепродажного обслуживания.',
      '实时定位与导航': 'Позиционирование и навигация в реальном времени',
      '北斗三号融合终端': 'Интегрированный терминал Beidou-3',
      '定位误差参数': 'Горизонтальная погрешность ≤3м, вертикальная погрешность <0.5м, поддержка связи короткими сообщениями в зонах без сигнала.',
      '生命体征监测': 'Мониторинг жизненных показателей',
      '单兵生命体征传感器': 'Датчик жизненных показателей спасателя (интегрирован в защитный костюм)',
      '生命体征参数': 'Мониторинг пульса, температуры тела, насыщения кислородом крови в реальном времени, автоматическая тревога при аномальных значениях.',
      '环境风险感知': 'Восприятие экологических рисков',
      '手持式长波红外成像气体检测仪': 'Портативный длинноволновый инфракрасный газовый детектор',
      '气体检测参数': 'Обнаружение 16 видов токсичных газов (CO, H₂S и т.д.), точность ±1ppm.',
      '氧气余量监控': 'Мониторинг остатка кислорода',
      '智能氧气瓶压力传感器': 'Интеллектуальный датчик давления кислородного баллона',
      '氧气监控参数': 'Отображение оставшегося времени кислорода в реальном времени, предупреждение о низком давлении (порог ≤5MPa).',
      '通讯与数据回传': 'Связь и передача данных',
      '卫星电话融合终端': 'Интегрированный терминал спутниковой связи',
      '通讯参数': 'Поддержка голосовых звонков, передача тепловизионных изображений в командный центр в реальном времени.',
      '多维度安全防护': 'Многоуровневая защита безопасности',
      '多维度安全防护描述': 'От физиологического состояния до экологических рисков, всесторонний мониторинг и предупреждение.',
      '轻量化集成设计': 'Легкая интегрированная конструкция',
      '轻量化集成设计描述': 'Общий вес <2кг, не влияет на мобильность спасателей.',
      '智能决策支持': 'Поддержка интеллектуальных решений',
      '智能决策支持描述': 'AI-алгоритм автоматически анализирует данные, предоставляет маршруты эвакуации и рекомендации по первой помощи.',
      '高层火灾': 'Пожар в высотном здании',
      '高层火灾描述': 'Позиционирование этажа через Beidou, предупреждение об остатке кислорода для предотвращения риска удушья.',
      '化工爆炸': 'Химический взрыв',
      '化工爆炸描述': 'Детектор газа в реальном времени подает сигнал тревоги, командный центр удаленно координирует маршруты эвакуации.',
      '地下隧道': 'Подземный туннель',
      '地下隧道描述': 'Функция коротких сообщений обеспечивает связь и позиционирование без сигнала GPS.',
    },
    'solution-details': {
        '解决方案标题': 'Решение',
        '方案详情': 'Детали решения',
        '文章标题': 'Заголовок статьи',
        '文章描述': 'Описание статьи',
        '一站式数据资产管理': 'Комплексное управление данными',
        '业务挑战': 'Бизнес-вызовы',
        '解决方案': 'Решение',
        '方案价值': 'Ценность решения',
        '1V1专家咨询': 'Консультация эксперта 1 на 1',
        '端到端解决方案，加速释放数据价值': 'Сквозное решение, ускоряющее извлечение ценности из данных',
        '数据平台': 'Платформа данных',
        '数据管理平台': 'Платформа управления данными',
        '数据仓库': 'Хранилище данных',
        '咨询流程': 'Процесс консультации',
        '需求咨询': 'Консультация по требованиям',
        '初步沟通': 'Предварительное общение',
        '方案交流': 'Обсуждение решения',
        '商务流程': 'Бизнес-процесс',
        '提交相关需求，描述业务背景': 'Отправка соответствующих требований, описание бизнес-контекста',
        '需求确认，对平台心疑惑，解决合作顾虑': 'Подтверждение требований, ответы на вопросы о платформе, решение проблем сотрудничества',
        '针对相关方案进行详述并就技术问题深讨': 'Подробное описание соответствующего решения и глубокое обсуждение технических вопросов',
        '方案确定后，开始执行商务流程': 'После определения решения начинается выполнение бизнес-процесса',
        '已截止': 'Закончено',
        '暂无数据': 'Нет данных'
    },
    // 新增 news-list 对象
    'news-list': {
        '新闻中心': 'Новостной центр',
        '中国智造 走向世界': 'Китайское интеллектуальное производство выходит на мировую арену',
        '点击查看更多': 'Нажмите, чтобы увидеть больше'
    },
    'news-details': {
      '新闻中心': 'Новостной центр',
      '新闻详情': 'Детали новостей',
      '发布日期': 'Дата публикации',
      '平台信息': 'Информация о платформе'
  },
  'contact-us': {
      '标题': 'Свяжитесь с нами',
      '展会介绍': 'Qinhang (Гуандун Хэнцинь) Технологии Лтд., как ведущая компания в области комплексного трансграничного сервиса авиакосмической промышленной продукции, всегда стремится предоставлять глобальным клиентам эффективные и профессиональные промышленные решения. Благодаря глубокому отраслевому опыту и инновационной модели обслуживания мы успешно создали мост между международными поставщиками и потребителями, способствуя эффективному развитию глобальной авиакосмической промышленности. На международных рынках, таких как Стамбул, Турция, Qinhang Technology создала обширную сеть сотрудничества, предоставляя клиентам полный спектр услуг от управления цепочкой поставок до технической поддержки через локализованные команды обслуживания и цифровые платформы. Наши услуги охватывают авиакосмические компоненты, оборудование и технологические решения, обеспечивая соответствие каждого этапа высочайшим международным стандартам. В будущем Qinhang Technology продолжит углублять глобальное развертывание, расширять новые рынки и вносить новый импульс в развитие глобальной авиакосмической промышленности. Мы с нетерпением ждем сотрудничества с большим количеством партнеров для создания блестящего будущего и продвижения отраслевого прогресса.',
      '电话': 'Телефон',
      '邮箱': 'Email: Kinghang@e99.cn',
      '图片描述': 'Свяжитесь с нами - Qinhang Technology участвует в выставке оборонной промышленности IDEF'
  },
  'about': {
    '关于我们': 'О нас',
    '更新时间': 'Обновлено: ',
            '新闻详情': 'Детали новостей',
            '了解琴航': 'О Qinhang',
            '琴航文化': 'Корпоративная культура',
            '核心优势': 'Основные преимущества',
            '股东背景': 'Акционеры',
            '政策支持': 'Политическая поддержка',
            '展望未来': 'Видение будущего',
            '您当前的位置：首页': 'Вы находитесь: Главная',
            '用户昵称': 'Имя пользователя',
            // 模块1
            '成立背景':'Предпосылки создания',
            'txt1':'Экономика низких высот как стратегическая новая отрасль имеет огромный потенциал, и государство активно развивает эту сферу. В последние годы область авиационной промышленной продукции быстро развивается, появилось множество передовых технологических компаний и сформировалась полная промышленная цепочка, однако трансграничная продажа авиационной промышленной продукции все еще находится на начальной стадии.',
            '公司简介':'О компании',
            'txt2':'Qinhang Technology - первая в Китае платформа, специализирующаяся на комплексном трансграничном сервисе авиакосмической промышленной продукции. Основанная в декабре 2024 года, она направлена на реализацию национальной стратегии "двойной циркуляции" и решение проблемы недостатка опыта в международной торговле для компаний авиационной промышленной цепочки.',
            '股东结构':'Структура акционеров',
            'txt3':'Структура акционеров Qinhang Technology возглавляется консорциумом государственных активов Чжухай, включая Dahengqin Group, Zhuhai Low-Altitude Industry Investment and Operation Company, Zhuhai Convention and Exhibition Group и другие. Кроме того, инвестиционная платформа Всекитайской торгово-промышленной палаты по технологическому оборудованию также участвует для усиления возможностей интеграции ресурсов.',
            '团队力量':'Команда',
            'txt4':'Члены основной команды пришли из China Aerospace Science and Technology, Poly Defense, военных учреждений, Langhua Group и других организаций, имеют более десяти лет опыта работы в области промышленной продукции, обладают богатыми внутренними и международными отраслевыми ресурсами, имеют прочную деловую основу в клиентских каналах, цепочке поставок, управлении соответствием, политике и законодательстве, финансах, логистике и других аспектах.',
            // 模块2
            '战略定位':'Стратегическое позиционирование',
            'txt5':'Руководствуясь моделью развития "один-два-три", высококачественно создаем "один стандарт, две экосистемы, три актива", включая один стандарт, две экосистемы (цифровая экосистема и промышленная экосистема), три актива (активы данных, технологические активы, активы бренда). Основная миссия - продвигать интернационализацию стандартов китайской авиационной промышленности, помочь Чжухаю стать ключевым городом авиационной промышленной цепочки.',
            '发展目标':'Цели развития',
            'txt6':'Основываясь на импорте и экспорте авиационной промышленной продукции, стремимся к созданию нормализованной, цифровой и интернациональной торговли и установлению совершенной системы управления данными, полной интеграции онлайн и оффлайн бизнеса, через накопление большого объема торговых данных и глубокое раскрытие отраслевого потенциала, содействие повышению возможностей китайской авиационной промышленности и построению стандартов, экспорт китайских стандартов авиационной промышленности в мир, стать ведущей в стране и всемирно известной платформой трансграничной торговли авиационной промышленной продукцией, продвигать агрегацию авиакосмической промышленности в районе Большого залива Гуандун-Гонконг-Макао, обслуживать глобальную цепочку поставок.',
            // 模块3
            'txt7':'Услуги трансграничной торговли Qinhang Technology охватывают весь процесс импорта и экспорта авиационной промышленной продукции (таможенное оформление, логистика, финансы, соответствие и т.д.). Благодаря управлению данными, используя накопление торговых данных, раскрывая отраслевой потенциал, расширяя возможности цепочки промышленности.',
            '技术亮点':'Технологические особенности',
            'txt8':'Цифровая платформа Qinhang Technology интегрирует ресурсы авиационных выставок, реализует синергетический онлайн и оффлайн сервис. В то же время, ориентируясь на международные стандарты, продвигает сертификацию и экспорт китайских авиационных промышленных технологий.',
            '差异化优势':'Дифференцированные преимущества',
            'txt9':'Государственный фон Qinhang Technology обеспечивает стабильность ресурсов, сервис полной промышленной цепочки снижает порог трансграничного бизнеса для предприятий.',
            '海外资源优势':'Преимущества международных ресурсов',
            'txt10':'Персонал основной команды Qinhang Technology имеет многолетний опыт международного обмена и сотрудничества. В то же время, опираясь на обширные канальные ресурсы Всекитайской торгово-промышленной палаты по технологическому оборудованию, может предоставлять услуги по стыковке международной цепочки поставок, расширению рынка и т.д. С другой стороны, как платформа трансграничной торговли, Qinhang имеет большую гибкость в управлении въездом и выездом персонала по сравнению с крупными государственными или центральными предприятиями или предприятиями в чувствительных отраслях или профессиях.',
            '股东资源':'Ресурсы акционеров',
            'txt11':'Qinhang Чжухай государственные активы - важное звено в стратегическом расположении группы в авиакосмической промышленной цепочке; в то же время, опираясь на ресурсы Китайской авиационной выставки, укрепляя преимущества бренда и каналов.',
            // 模块4
            '横琴战略地位':'Стратегическое положение Хэнцинь',
            'txt12':'Qinhang Technology расположена в центре зоны глубокого сотрудничества Гуандун-Гонконг-Макао, пользуется политическими бонусами в области трансграничных финансов, налогообложения и других. Граничит с Макао, является "супер-портом", соединяющим международные рынки.',
            '政策赋能':'Политическая поддержка',
            'txt13':'Qinhang Technology включена в "Общий план развития Хэнцинь", поддерживает высокотехнологичное производство и инновации трансграничных услуг. Город Чжухай также создает кластер авиационной промышленности, Qinhang Technology является одним из ключевых носителей.',
            // 模块5
            '短期规划':'Краткосрочные планы',
            'txt14':'Qinhang Technology усовершенствует функции платформы, расширит области охвата трансграничных услуг, такие как экономика низких высот, промышленная цепочка БПЛА и т.д.',
            '长期愿景':'Долгосрочное видение',
            'txt15':'Стать глобальным торговым узлом авиационной промышленной продукции, продвигать экспорт китайских стандартов и технологий. В то же время, содействовать строительству Хэнцинь как "умного острова", исследовать применение блокчейна и ИИ в трансграничной торговле.',
            'txt16':'В будущем Dahengqin Group будет активно реагировать на национальные, провинциальные и городские планы развития экономики низких высот, в полной мере использовать политические и географические преимущества города Чжухай и зоны глубокого сотрудничества Хэнцинь Гуандун-Макао, полностью поддерживать строительство и долгосрочное развитие Qinhang Technology, базируясь в Чжухае, обслуживая всю страну, распространяясь по всему миру, вносить прочный вклад в продвижение развития национальной экономики низких высот и совершенствование авиакосмической промышленной цепочки Чжухая.',
  
        'hotProducts': 'Популярные категории продуктов',
        'productCategories': `Производство интеллектуальных БПЛА<br>
                             БПЛА<br>
                             Пропеллеры<br>
                             Электронные компоненты RC`,
  
        'helpSupport': 'Помощь и поддержка',
        'platformRules': 'Правила платформы',
        'commonQuestions': 'Часто задаваемые вопросы',
        'securityGuarantee': 'Гарантия безопасности',
        'contactUs': 'Свяжитесь с нами',
  
        'aboutQinhang': 'О Qinhang',
        'aboutUs': 'О компании Qinhang',
        'joinUs': 'Присоединяйтесь к нам',
        'investorRelations': 'Инвесторские отношения',
        'sustainability': 'Устойчивое развитие',
        'reportMisconduct': 'Сообщить о нарушении',
  
        'newsUpdates': 'Новости',
        'companyNews': 'Новости Qinhang',
        'industryTrends': 'Отраслевые тренды',
        'latestTech': 'Последние технологии',
        'companyAddress': 'Адрес: Здание 7, Комната 708-2, Международный научно-технический инновационный центр Хэнцинь, Хоупу Роуд 398, Район Сянчжоу, Чжухай',
        'copyright': `Все права защищены&nbsp;©&nbsp;2025&nbsp;Qinhang (Гуандун Хэнцинь) Технологии Лтд.&nbsp;&nbsp;|&nbsp;&nbsp;Политика конфиденциальности&nbsp;&nbsp;|&nbsp;&nbsp;Условия использования&nbsp;&nbsp;|&nbsp;&nbsp;粤ICP备2025393208号-1&nbsp;&nbsp;|&nbsp;&nbsp;Карта сайта` ,
  },
  'collect-list': {
      "我的收藏": "Мое избранное",
      "返回个人中心": "Вернуться в личный кабинет",
      "取消收藏": "Удалить из избранного",
      "暂无产品": "Товары не найдены"
  },
  'shop-list': {
      "未提交购物车": "Неотправленная корзина",
      "返回个人中心": "Вернуться в личный кабинет",
      "取消": "Отмена",
      "暂无产品": "Товары не найдены",
      '提交': 'Отправить',
  },
  'submit-list': {
      "购物车提交记录": "История отправок корзины",
      "返回个人中心": "Вернуться в личный кабинет",
      "暂无提交记录": "Нет записей отправок"
  },
  'submit-detail': {
      '购物车提交记录详情': 'Детали отправки корзины',
      "返回购物车提交记录页": "Вернуться к истории отправок",
  },
  'Card1': {
      '个人中心': 'Личный кабинет',
      '供应商': 'Поставщик',
      '采购商': 'Закупщик',
      '已完成企业认证': 'Корпоративная верификация завершена',
      '未完成企业认证': 'Корпоративная верификация не завершена',
      '认证审核中': 'Верификация на рассмотрении',
      '审核未通过,请重新认证': 'Проверка не пройдена, пожалуйста, пройдите верификацию заново',
      '编辑资料': 'Редактировать профиль',
      '认证信息': 'Информация о верификации',
      '退出登录': 'Выйти',
      '是否确认退出?': 'Вы уверены, что хотите выйти?',
      '提示': 'Уведомление',
      '确定': 'Подтвердить',
      '取消': 'Отмена',
      '是否翻译':'Перевести информацию о продукте на китайском?',
      '翻译产品':'Перевести продукты'
  },
  'Card2': {
      '本月订单总额': 'Общая сумма заказов за месяц',
      '较上月增长': 'Рост по сравнению с прошлым месяцем',
      '较上月降低': 'Снижение по сравнению с прошлым месяцем',
      '较上月无变化': 'Без изменений по сравнению с прошлым месяцем'
  },
  'Card3': {
      '待处理订单': 'Ожидающие заказы',
      '查看详情': 'Посмотреть детали'
  },
  'Card4': {
      '退货订单': 'Возвраты',
      '查看详情': 'Посмотреть детали'
  },
  'Card5': {
      '我的订单': 'Мои заказы',
      '查看全部': 'Посмотреть все',
      '待付款': 'Ожидание оплаты',
      '待发货': 'Ожидание отправки',
      '待收货': 'Ожидание доставки',
      '收货完成': 'Доставлено',
      '退换货': 'Возврат/Обмен'
  },
  'Card6': {
      '采购需求': 'Запросы на закупку',
      '需求管理': 'Управление запросами',
      '有效采购需求': 'Активные запросы на закупку',
      '待审核需求': 'Запросы на рассмотрении'
  },
  'Card7': {
      '账户安全': 'Безопасность аккаунта',
      '安全等级': 'Уровень безопасности',
      '企业认证': 'Корпоративная верификация',
      '已认证': 'Верифицирован',
      '未完成企业认证': 'Корпоративная верификация не завершена',
      '审核未通过,请重新认证': 'Проверка не пройдена, пожалуйста, пройдите верификацию заново',
      '认证审核中': 'Верификация на рассмотрении',
      '高': 'Высокий',
  },
  'Card8': {
      '收藏夹': 'Избранное',
      '查看全部': 'Посмотреть все',
      '暂无收藏产品': 'Нет избранных товаров'
  },
  'Card9': {
      '消息中心': 'Центр сообщений',
      '查看全部': 'Посмотреть все',
      '订单发货通知': 'Уведомление об отправке заказа',
      '您的订单 {orderId} 已发货': 'Ваш заказ {orderId} отправлен',
      '{time} 前': '{time} назад'
  },
  'Card10': {
      '我的产品': 'Мои товары',
      '新增产品': 'Добавить товар',
      '全部': 'Все',
      '已上架': 'Опубликовано',
      '未上架': 'Не опубликовано',
      '审核中': 'На рассмотрении',
      '审核通过': 'Одобрено',
      '审核失败': 'Отклонено',
      '提交审核': 'Отправить на проверку',
      '下架': 'Снять с публикации',
      '上架': 'Опубликовать',
      '编辑': 'Редактировать',
      '删除': 'Удалить',
      '暂无产品': 'Нет товаров',
      '上传图片': 'Загрузить изображения',
      '导入产品': 'Импортировать товары',
  },
  'Card11': {
      '我的产品': 'Мои товары',
      '新增需求': 'Добавить запрос',
      '返回个人中心': 'Вернуться в личный кабинет',
      '全部': 'Все',
      '审核中': 'На рассмотрении',
      '审核通过': 'Одобрено',
      '审核失败': 'Отклонено',
      '提交审核': 'Отправить на проверку',
      '编辑': 'Редактировать',
      '删除': 'Удалить',
      '暂无需求': 'Нет запросов',
      "已通过": "Одобрено",
      "审核中1": "На рассмотрении",
      "未通过": "Отклонено",
      "未审核": "Не проверено"
  },
  'Card12': {
      '我的订单': 'Мои заказы',
      '返回个人中心': 'Вернуться в личный кабинет',
      '所有订单': 'Все заказы',
      '待付款': 'Ожидание оплаты',
      '待发货': 'Ожидание отправки',
      '已发货': 'Отправлено',
      '收货完成': 'Доставлено',
      '退换货': 'Возврат/Обмен',
      '暂无需求': 'Нет запросов',
      '提交审核': 'Отправить на проверку',
      '编辑': 'Редактировать',
      '删除': 'Удалить',
      '退款': 'Возврат средств'
  },
  'Card13': {
      '未提交购物车': 'Неотправленная корзина',
      '查看全部': 'Посмотреть все',
      '暂无产品': 'Нет товаров'
  },
  'Card14': {
      '购物车提交记录': 'История отправок корзины',
      '查看全部': 'Посмотреть все',
      '暂无提交记录': 'Нет записей отправок'
  },
  'userEdit': {
      "修改个人信息": "Изменить личную информацию",
      "头像": "Аватар",
      "用户名称": "Имя пользователя",
      "同步登录账号": "Синхронизировать с логином",
      "手机号": "Номер телефона",
      "邮箱": "Email",
      "请输入": "Пожалуйста, введите",
      "请输入正确的手机号": "Пожалуйста, введите правильный номер телефона",
      "请输入正确的邮箱": "Пожалуйста, введите правильный email",
      "提 交": "Отправить",
      "修改成功": "Успешно изменено"
  },
  'login': {
      '用户登录': 'Вход пользователя',
      '请输入用户名': 'Имя пользователя',
      '密码': 'Пароль',
      '登录': 'Войти',
      '没有账户?立即注册': 'Нет аккаунта? Зарегистрироваться',
      
      '未登录或登录过期，请重新登录': 'Не выполнен вход или сессия истекла, пожалуйста, войдите снова',
      '提示': 'Уведомление',
      '取消': 'Отмена',
  },
  'register': {
    '用户注册': 'Регистрация пользователя',
    '已有账号，去登录': 'Уже есть аккаунт? Войти',
    '用户名': 'Имя пользователя',
    '邮箱': 'Email',
    '密码': 'Пароль',
    '再次输入密码': 'Повторите пароль',
    '用户类型': 'Тип пользователя',
    '采购商': 'Закупщик',
    '供应商': 'Поставщик',
    '注册': 'Зарегистрироваться',
    '请输入用户名称': 'Введите имя пользователя',
    '请输入邮箱': 'Введите email',
    '请输入正确的邮箱格式': 'Введите правильный формат email',
    '请输入密码': 'Введите пароль',
    '请再次输入密码': 'Повторите пароль',
    '请选择用户类型': 'Выберите тип пользователя'
  },
  'personalCenter': {
      '企业认证': 'Корпоративная верификация',
      '基本信息（必填）': 'Основная информация (обязательно)',
      '营业执照': 'Лицензия на ведение бизнеса',
      '企业名称': 'Название компании',
      '联系人': 'Контактное лицо',
      '法定代表人身份证': 'Удостоверение личности законного представителя',
      '联系电话': 'Контактный телефон',
      '组织机构代码': 'Код организации',
      '企业资质信息': 'Информация о квалификации компании',
      '税务登记证': 'Налоговая регистрация',
      '组织机构代码证': 'Сертификат организационного кода',
      '开户许可证': 'Разрешение на открытие счета',
      '企业资质与能力': 'Квалификация и возможности компании',
      '行业经营资质': 'Квалификация отрасли',
      '生产或代理资质': 'Производственная или агентская квалификация',
      '质量管理体系认证': 'Сертификация системы управления качеством',
      '环保与安全资质': 'Экологическая и безопасная квалификация',
      '供货能力证明': 'Доказательство возможности поставки',
      '售后服务能力证明': 'Доказательство возможности послепродажного обслуживания',
      '产品资质相关': 'Связанные с квалификацией продукта',
      '产品质量检测报告': 'Отчет о контроле качества продукции',
      '产品认证证书': 'Сертификат продукта',
      '产品说明书': 'Инструкции по продукту',
      '其他材料': 'Другие материалы',
      '信用证明': 'Кредитный сертификат',
      '无违规声明': 'Заявление об отсутствии нарушений',
      '电商平台运营经验证明': 'Доказательство опыта работы на электронных платформах',
      '企业荣誉': 'Награды компании',
      '其他相关资质或证明材料': 'Другие соответствующие квалификации или доказательства',
      '提交': 'Отправить',
      '图片或文件': 'Изображение или файл',
      '请上传营业执照': 'Загрузите бизнес-лицензию',
      '请输入企业名称': 'Введите название компании',
      '企业名称长度在2到50个字符之间': 'Длина названия компании должна быть от 2 до 50 символов',
      '请输入联系人姓名': 'Введите имя контактного лица',
      '联系人姓名长度在2到20个字符之间': 'Длина имени контактного лица должна быть от 2 до 20 символов',
      '邮箱': 'Email',
      '请输入邮箱地址': 'Введите email-адрес',
      '请输入联系电话': 'Введите контактный телефон'
  },
  'personalCenter2': {
      '企业认证': 'Корпоративная верификация',
      '基本信息（必填）': 'Основная информация (обязательно)',
      '业务信息（必填）': 'Бизнес-информация (обязательно)',
      '联系方式（必填）': 'Контактная информация (обязательно)',
      '资质相关（必填）': 'Квалификация (обязательно)',
      '企业名称': 'Название компании',
      '公司注册地址': 'Адрес регистрации компании',
      '公司注册编号': 'Регистрационный номер компании',
      '成立时间': 'Дата основания',
      '公司规模': 'Размер компании',
      '采购品类': 'Категории закупок',
      '年采购额范围': 'Диапазон годового объема закупок',
      '主要采购市场': 'Основные рынки закупок',
      '预计月采购量': 'Ожидаемый месячный объем закупок',
      '公司邮箱': 'Email компании',
      '公司电话': 'Телефон компании',
      '公司网站': 'Веб-сайт компании',
      '办公地址': 'Офисный адрес',
      '公司营业执照': 'Бизнес-лицензия компании',
      '进出口贸易许可证': 'Лицензия на импорт/экспорт',
      '银行账户证明': 'Подтверждение банковского счета',
      '提交': 'Отправить',
      '图片或文件': 'Изображение или файл',
      '提交成功，请耐心等待客服审核通过': 'Успешно отправлено, пожалуйста, дождитесь одобрения',
      '提示': 'Уведомление',
      '确定': 'Подтвердить',
      '取消': 'Отмена',
      '提交失败，请稍后重试': 'Не удалось отправить, попробуйте позже',
      '请完善必填信息': 'Пожалуйста, заполните обязательные поля',
      '请输入企业名称': 'Введите название компании',
      '请输入公司注册地址': 'Введите адрес регистрации компании',
      '请输入公司注册编号': 'Введите регистрационный номер компании',
      '请选择成立时间': 'Выберите дату основания',
      '请选择公司规模': 'Выберите размер компании',
      '请选择采购品类': 'Выберите категории закупок',
      '请选择年采购额范围': 'Выберите диапазон годового объема закупок',
      '请选择主要采购市场': 'Выберите основные рынки закупок',
      '请输入预计月采购量': 'Введите ожидаемый месячный объем закупок',
      '请输入公司邮箱': 'Введите email компании',
      '请输入公司电话': 'Введите телефон компании',
      '请输入公司网站': 'Введите веб-сайт компании',
      '请输入办公地址': 'Введите офисный адрес',
      '请上传公司营业执照': 'Загрузите бизнес-лицензию компании',
      '请上传进出口贸易许可证': 'Загрузите лицензию на импорт/экспорт',
      '请上传银行账户证明': 'Загрузите подтверждение банковского счета'
  },
      'solution4':{
          'txt1':'Точное восприятие · Движущая сила глобального интеллектуального производства',
          'txt2':'В высокоточных областях, таких как промышленная автоматизация, навигация БПЛА, управление роботами, автомобильная электроника, выбор гироскопа напрямую связан с производительностью и надежностью оборудования. Как профессиональная платформа трансграничной торговли промышленной продукцией, мы глубоко понимаем проблемы, с которыми сталкиваются клиенты при выборе продукции:',
          'txt3':'Сложные параметры: как сопоставить диапазон, стабильность нулевого смещения, шум и другие показатели со сценариями применения',
          'txt4':'Суровые условия: как обеспечить стабильность в условиях высокой температуры, ударов, вибрации',
          'txt5':'Сложности интеграции: как оптимизировать совместимость интерфейсов и конструкцию схем',
          'txt6':'Наше решение: на основе технологических преимуществ серии MEMS-гироскопов ASG1000 мы предоставляем "точную поддержку выбора + полный цикл технических услуг", помогая вам быстро реализовать интеграцию продукта и массовое производство',
          'txt7':'Основные преимущества серии ASG1000',
          'txt8':'Производительность военного класса, соответствие суровым условиям',
          'txt9':'Высокая точность: стабильность нулевого смещения до 0.5 dph (ASG1100-P5), случайное блуждание угла 0.06°/√h, применимо для точной навигации и контроля ориентации',
          'txt10':'Широкий диапазон температур: рабочая температура от -55℃ до +125℃, прошедшая испытания GJB 150.3A/4A на высокие и низкие температуры, адаптируется к экстремальным промышленным условиям',
          'txt11':'Устойчивость к ударам и вибрации: выдерживает удары 4000g, надежность вибрации 6.06grms, соответствует стандарту GJB 150.18A, обеспечивает долгосрочную стабильную работу оборудования',
          'txt12':'Гибкая адаптация, охват нескольких сценариев',
          
          'txt13':'Plug-and-play дизайн, быстрая интеграция',
          'txt14':'Стандартный интерфейс SPI: поддержка скорости передачи данных ≥2kHz, совместимость с основными контроллерами',
          'txt15':'Компактная упаковка: размер 11mm×11mm, подходит для устройств с ограниченным пространством',
          'txt16':'Руководство по оптимизации схем: предоставляет определение выводов, рекомендации по подбору конденсаторов (например, внешний конденсатор 1μF для V4P5), сокращает цикл разработки',
          
          'txt17':'Наши услуги: полное сопровождение от выбора до массового производства',
          'txt18':'Точная поддержка выбора',
          'txt19':'Соответствие сценариям: рекомендация оптимальной модели в соответствии с вашими потребностями применения (такими как диапазон, окружающая среда, потребление энергии)',
          'txt20':'Пример: для управления полетом БПЛА требуется высокая динамическая реакция, серия ASG1500 с полосой пропускания 100Hz обеспечивает настройку ориентации в реальном времени',
          'txt21':'Сравнительный анализ параметров: предоставление интерпретации ключевых показателей, таких как повторяемость нулевого смещения, нелинейность, избежание рисков проектирования',
          
          'txt22':'Техническое содействие',
          'txt23':'Пакет референсного дизайна: содержит схемы, рекомендации по разводке печатных плат, драйверный код, ускоряет разработку',
          'txt24':'Индивидуальные услуги: поддержка OEM/ODM, оптимизация упаковки или протокола вывода, удовлетворение специальных потребностей',
          'txt25':'Гарантия качества и цепочки поставок',
          'txt26':'Полный контроль качества: соответствие военным стандартам испытаний GJB 548B, GJB 7952, 100% заводской контроль',
          'txt27':'Беззаботная трансграничная логистика: глобальная сеть складов и дистрибуции, предоставление услуг DDP/DAP, обеспечение своевременной доставки',
          
          'txt28':'Другие преимущества',
          'txt29':'Техническая поддержка',
          'txt30':'Продукт создан командой военных технологий, 10-летний опыт разработки MEMS-датчиков',
          'txt31':'Комплексное обслуживание',
          'txt32':'От консультации по выбору, тестирования образцов до массовых закупок, полная поддержка',
          'txt33':'Прозрачность данных',
          'txt34':'Предоставление отчетов сторонних испытаний (таких как коэффициент вибрационного выпрямления, кривая температурного дрейфа), обеспечивая уверенность клиентов в закупках',
          
          'tab1': 'Модель',
          'tab2': 'Диапазон',
          'tab3': 'Ключевые характеристики',
          'tab4': 'Типичные сценарии применения',
          'tab5': 'Сверхнизкий шум, высокая стабильность',
          'tab6': 'Стабилизация высоты БПЛА, точные приборы',
          'tab7': 'Высокая полоса пропускания (≥100Hz), сильная виброустойчивость',
          'tab8': 'Промышленные роботы, автономное вождение',
      },
      AddDemand: {
          'xzcgxq': 'Добавить запрос на закупку',
          'bjcgxq': 'Редактировать запрос на закупку',
          'cpmc': 'Название продукта',
          'cplb': 'Категория продукта',
          'cgsl': 'Количество закупки',
          'dw': 'Единица измерения',
          'ysje': 'Бюджетная сумма',
          'jhqx': 'Срок поставки',
          'bmjzsj': 'Крайний срок подачи заявки',
          'cpzt': 'Главное изображение продукта',
          'cpxjt': 'Детальные изображения продукта',
          'cpfj': 'Вложения продукта',
          'cpyqxq': 'Детали требований к продукту',
          'qsr': 'Пожалуйста, введите',
          'qxz': 'Пожалуйста, выберите',
          'tbdxjt': 'Синхронизировать с детальными изображениями',
          'tj': 'Отправить',
          'qsrcpmc': 'Пожалуйста, введите название продукта',
          'qsrcgsl': 'Пожалуйста, введите количество закупки',
          'qsrdw': 'Пожалуйста, введите единицу измерения',
          'qxzcplb': 'Пожалуйста, выберите категорию продукта',
          'qsrysje': 'Пожалуйста, введите бюджетную сумму',
          'qsrjhqx': 'Пожалуйста, введите срок поставки',
          'qxzbmjzsj': 'Пожалуйста, выберите крайний срок подачи заявки',
          'qsrcpgxq': 'Пожалуйста, введите требования к спецификациям продукта',
          'qsccpzt': 'Пожалуйста, загрузите главное изображение продукта',
          'qsccpxjt': 'Пожалуйста, загрузите детальные изображения продукта',
          'xgcg': 'Успешно изменено',
          'xzcg': 'Успешно добавлено',
          'hqcgxqxqsb': 'Не удалось получить детали запроса на закупку'
      },
      product: {
          '请先登录后查看产品详情': 'Пожалуйста, войдите, чтобы просмотреть детали продукта',
          '请先登录后继续操作': 'Пожалуйста, войдите, чтобы продолжить',
          '提示': 'Уведомление',
          '去登录': 'Перейти к входу',
          '取消': 'Отмена'
      },
  };
  export default ru_RU;
  